// extracted by mini-css-extract-plugin
export default {"loading_text":"loading_loading_text__4nMzC","loader":"loading_loader__+Aej7","spin":"loading_spin__CS+rN"};